/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ListAnimalsByOrganizationQueryResponse, ListAnimalsByOrganizationPathParams, ListAnimalsByOrganizationQueryParams, ListAnimalsByOrganization400, ListAnimalsByOrganization401, ListAnimalsByOrganization403, ListAnimalsByOrganization404, ListAnimalsByOrganization409, ListAnimalsByOrganization500 } from "../../types/livestockController/ListAnimalsByOrganization.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { listAnimalsByOrganization } from "../../client/livestockController/listAnimalsByOrganization.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const listAnimalsByOrganizationQueryKey = (organizationId: ListAnimalsByOrganizationPathParams["organizationId"] | undefined, params?: ListAnimalsByOrganizationQueryParams) => [{ url: '/api/organizations/:organizationId/animals', params: {organizationId:organizationId} }, ...(params ? [params] : [])] as const

export type ListAnimalsByOrganizationQueryKey = ReturnType<typeof listAnimalsByOrganizationQueryKey>

export function listAnimalsByOrganizationQueryOptions(organizationId: ListAnimalsByOrganizationPathParams["organizationId"] | undefined, params?: ListAnimalsByOrganizationQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = listAnimalsByOrganizationQueryKey(organizationId, params)
        return queryOptions<ListAnimalsByOrganizationQueryResponse, ResponseErrorConfig<ListAnimalsByOrganization400 | ListAnimalsByOrganization401 | ListAnimalsByOrganization403 | ListAnimalsByOrganization404 | ListAnimalsByOrganization409 | ListAnimalsByOrganization500>, ListAnimalsByOrganizationQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return listAnimalsByOrganization(organizationId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List animals across the organization (optionally one farm via ?establishmentId)
 * {@link /api/organizations/:organizationId/animals}
 */
export function useListAnimalsByOrganization<TData = ListAnimalsByOrganizationQueryResponse, TQueryData = ListAnimalsByOrganizationQueryResponse, TQueryKey extends QueryKey = ListAnimalsByOrganizationQueryKey>(organizationId: ListAnimalsByOrganizationPathParams["organizationId"] | undefined, params?: ListAnimalsByOrganizationQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ListAnimalsByOrganizationQueryResponse, ResponseErrorConfig<ListAnimalsByOrganization400 | ListAnimalsByOrganization401 | ListAnimalsByOrganization403 | ListAnimalsByOrganization404 | ListAnimalsByOrganization409 | ListAnimalsByOrganization500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? listAnimalsByOrganizationQueryKey(organizationId, params)
         

         const query = useQuery({
          ...listAnimalsByOrganizationQueryOptions(organizationId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ListAnimalsByOrganization400 | ListAnimalsByOrganization401 | ListAnimalsByOrganization403 | ListAnimalsByOrganization404 | ListAnimalsByOrganization409 | ListAnimalsByOrganization500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}